<app-banner
  [link]="'/birthdays'"
  [icon]="'cake'"
  [title]="'components.birthdaysBanner.labels.title' | translate"
  [description]="'components.birthdaysBanner.labels.description' | translate"
></app-banner>
